import React from "react";
import Loading from "../../components/common/loading";

import { Switch, Route } from "react-router-dom";

import SubHeader from "../../components/common/topHeader/subHeader";
// import CalenderInput from "../../components/common/inputs/calenderInput";
import DevicePageInlet from "./sections/devicePageInlet";
import DevicePageOutlets from "./sections/devicePageOutlet";
import DeviceDetails from "./sections/deviceDetails";
import DevicePageOutletPage from "./sections/devicePageOutletPage";
import DevicePageSensors from "./sections/devicePageSensors";
import DevicePageAlerts from "./sections/devicePageAlerts";
import DevicePageAlertItemPage from './deviceAlertsItemPage';
import LoggingEventLogs from '../logging/eventLogs';
import DevicePageConfiguration from "./sections/devicePageConfiguration";

import axios from "axios";
import NotificationManager from "../../utils/notificationManager";
export default class ConnectedDevicePage extends React.Component {
  outletsRequest = null;
  inletsRequest = null;
  banksRequest = null;
  sensorsRequest = null;
  eventsRequest = null;
  confRequest = null;
  confRequestSerial = null;

  state = {
    device: null,
    deviceLoading: false,
    deviceLoaded: false,

    outletsLoading: false,
    outletsLoaded: false,
    inletsLoading: false,
    inletsLoaded: false,
    banksLoading: false,
    banksLoaded: false,
    sensorsLoading: false,
    sensorsLoaded: false,
    eventsLoading: false,
    eventsLoaded: false,

    conf: null,
    confLoading: false,
    confSerial: null,

    deviceOffline: false,
    deviceOfflineReason: null,

    activityLoading: false,
    activityLog: [],
    activityMeta: {},
    activityPage: 1,
    activityLoaded: false,
    activityFilter: "",
  };

  normalizeDevice = (device) => {
    if (!device) return null;

    const normalizedSerial =
      device.enclosureSerialNumber === undefined ||
      device.enclosureSerialNumber === null
        ? device.enclosureSerialNumber
        : String(device.enclosureSerialNumber);

    return {
      ...device,
      enclosureSerialNumber: normalizedSerial,
      outlets: Array.isArray(device.outlets) ? device.outlets : [],
      inlets: Array.isArray(device.inlets) ? device.inlets : [],
      sensors: Array.isArray(device.sensors) ? device.sensors : [],
      banks: Array.isArray(device.banks) ? device.banks : [],
      events: Array.isArray(device.events) ? device.events : [],
    };
  };

  setDeviceData = (data, extraState = {}) => {
    if (!data) {
      this.setState(extraState);
      return;
    }

    this.setState((prevState) => {
      const prevDevice = prevState.device;
      const prevSerialRaw = prevDevice?.enclosureSerialNumber;
      const prevSerial =
        prevSerialRaw === undefined || prevSerialRaw === null
          ? prevSerialRaw
          : String(prevSerialRaw);
      const nextSerialRaw =
        data.enclosureSerialNumber !== undefined
          ? data.enclosureSerialNumber
          : prevSerialRaw;
      const nextSerial =
        nextSerialRaw === undefined || nextSerialRaw === null
          ? nextSerialRaw
          : String(nextSerialRaw);

      const isNewSerial =
        Boolean(nextSerial) &&
        (prevSerial === undefined || prevSerial === null
          ? true
          : nextSerial !== prevSerial);

      const baseDevice = isNewSerial ? {} : prevDevice || {};
      const mergedDevice = this.normalizeDevice({
        ...baseDevice,
        ...data,
      });

      const resetFlags = isNewSerial
        ? {
            outletsLoading: false,
            outletsLoaded: false,
            inletsLoading: false,
            inletsLoaded: false,
            banksLoading: false,
            banksLoaded: false,
            sensorsLoading: false,
            sensorsLoaded: false,
            eventsLoading: false,
            eventsLoaded: false,
          }
        : {};

      return {
        device: mergedDevice,
        ...resetFlags,
        ...extraState,
      };
    });
  };

  deviceSupportsOutlets = () => {
    const device = this.state.device;
    if (!device) return null;

    return Boolean(
      device.outletSwitchingSupported || device.outletPwrMeasurementsSupported
    );
  };

  isOfflineError = (error) => {
    return (
      error?.response?.status === 503 &&
      error?.response?.data?.code === "DEVICE_OFFLINE"
    );
  };

  offlineMessageFromError = (error, fallback = "Device is offline.") => {
    return error?.response?.data?.message || fallback;
  };


  currentSerial = () => {
    const rawSerial =
      this.state.device?.enclosureSerialNumber ??
      this.props.match.params.enclosureSerialNumber;
    return rawSerial === undefined || rawSerial === null
      ? rawSerial
      : String(rawSerial);
  };

  componentDidMount() {
    const serial = this.props.match.params.enclosureSerialNumber;
    const foundDevice = this.props.resources.devices?.find(
      (d) =>
        d?.enclosureSerialNumber !== undefined &&
        d?.enclosureSerialNumber !== null &&
        String(d.enclosureSerialNumber) === String(serial)
    );
    if (foundDevice) {
      this.setDeviceData(foundDevice);
    }
    this.setState({
      deviceLoading: true,
      deviceLoaded: false,
    });
    this.grabDeviceData();
    this.grabActivityLog(1);
    this.props.fetchFwStatus(serial);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !this.state.device &&
      this.props.resources.devices !== prevProps.resources.devices
    ) {
      const serial = this.props.match.params.enclosureSerialNumber;
      const foundDevice = this.props.resources.devices?.find(
        (d) =>
          d?.enclosureSerialNumber !== undefined &&
          d?.enclosureSerialNumber !== null &&
          String(d.enclosureSerialNumber) === String(serial)
      );
      if (foundDevice) {
        this.setDeviceData(foundDevice);
      }
    }

    const prevSerialRaw = prevState.device?.enclosureSerialNumber;
    const currentSerialRaw = this.state.device?.enclosureSerialNumber;
    const prevSerial =
      prevSerialRaw === undefined || prevSerialRaw === null
        ? prevSerialRaw
        : String(prevSerialRaw);
    const currentSerial =
      currentSerialRaw === undefined || currentSerialRaw === null
        ? currentSerialRaw
        : String(currentSerialRaw);

    if (currentSerial && currentSerial !== prevSerial) {
      this.fetchConf({ useCache: false, device: this.state.device, force: true });
      this.ensureSectionData(this.props.location.pathname);
    }

    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.ensureSectionData(this.props.location.pathname);
    }

    if (!prevState.deviceLoaded && this.state.deviceLoaded) {
      this.ensureSectionData(this.props.location.pathname);
    }
  }

  grabDeviceData = () => {
    const serial = this.props.match.params.enclosureSerialNumber;
    this.props.getDeviceItemAndData(serial, (err, res) => {
      if (err) {
        console.error("Error fetching device data:", err);
        this.setState({
          deviceLoading: false,
          deviceLoaded: true,
        });
        return;
      }

      const deviceData = res?.data?.data;
      const offline = Boolean(res?.offline);
      const offlineMessage = offline
        ? res?.message || "Device is offline. Displaying last known information."
        : null;

      this.setDeviceData(deviceData, {
        deviceLoading: false,
        deviceLoaded: true,
        deviceOffline: offline,
        deviceOfflineReason: offline ? offlineMessage : null,
      });
      this.ensureSectionData(this.props.location.pathname);
    });
  };

  ensureSectionData = (pathname = this.props.location.pathname) => {
    const serial = this.currentSerial();
    if (!serial) return;

    const path = pathname || "";
    const supportsOutlets = this.deviceSupportsOutlets();
    const shouldFetchOutlets = supportsOutlets === true;

    if (path.includes("/outlets") && shouldFetchOutlets) {
      this.fetchDeviceOutlets();
    }

    if (path.includes("/inlets")) {
      this.fetchDeviceInlets();
      this.fetchDeviceBanks();
    }

    if (path.includes("/alerts")) {
      this.fetchDeviceEvents();
      if (shouldFetchOutlets) {
        this.fetchDeviceOutlets();
      }
      this.fetchDeviceSensors();
      this.fetchDeviceBanks();
    }

    if (path.includes("/details") && shouldFetchOutlets) {
      this.fetchDeviceOutlets();
    }
  };

  refreshAllData = () => {
    const serial = this.currentSerial();
    if (!serial) return;

    this.setState({ deviceLoading: true });

    this.grabDeviceData();
    if (this.deviceSupportsOutlets() === true) {
      this.fetchDeviceOutlets({ serial, force: true });
    }
    this.fetchDeviceInlets({ serial, force: true });
    this.fetchDeviceBanks({ serial, force: true });
    this.fetchDeviceSensors({ serial, force: true });
    this.fetchDeviceEvents({ serial, force: true });
    this.fetchConf({ useCache: false, force: true });
  };

  fetchDeviceOutlets = ({ serial, force = false } = {}) => {
    const targetSerial = serial || this.currentSerial();
    if (!targetSerial) return Promise.resolve([]);

    const supportsOutlets = this.deviceSupportsOutlets();
    if (supportsOutlets === false) {
      this.setState((prevState) => {
        if (!prevState.outletsLoading && prevState.outletsLoaded) {
          return null;
        }

        return {
          outletsLoading: false,
          outletsLoaded: true,
        };
      });
      return Promise.resolve(this.state.device?.outlets || []);
    }

    if (supportsOutlets !== true) {
      return Promise.resolve(this.state.device?.outlets || []);
    }

    if (this.state.outletsLoading && this.outletsRequest) {
      return this.outletsRequest;
    }

    if (this.state.outletsLoaded && !force) {
      return Promise.resolve(this.state.device?.outlets || []);
    }

    this.setState({ outletsLoading: true });

    const encodedSerial = encodeURIComponent(targetSerial);
    const request = axios
      .get(`/v2/devices/${encodedSerial}/outlets`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const outlets = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.setDeviceData(
          { enclosureSerialNumber: targetSerial, outlets },
          {
            outletsLoading: false,
            outletsLoaded: true,
            deviceOffline: false,
            deviceOfflineReason: null,
          }
        );
        return outlets;
      })
      .catch((err) => {
        if (this.isOfflineError(err)) {
          const outlets = Array.isArray(err?.response?.data?.data)
            ? err.response.data.data
            : [];
          const message = this.offlineMessageFromError(
            err,
            "Device is offline. Showing last known outlet information."
          );

          this.setDeviceData(
            { enclosureSerialNumber: targetSerial, outlets },
            {
              outletsLoading: false,
              outletsLoaded: true,
              deviceOffline: true,
              deviceOfflineReason: message,
            }
          );
          return outlets;
        }

        console.error(err);
        this.setState({ outletsLoading: false });
        throw err;
      })
      .finally(() => {
        this.outletsRequest = null;
      });

    this.outletsRequest = request;
    return request;
  };

  fetchDeviceInlets = ({ serial, force = false } = {}) => {
    const targetSerial = serial || this.currentSerial();
    if (!targetSerial) return Promise.resolve([]);

    if (this.state.inletsLoading && this.inletsRequest) {
      return this.inletsRequest;
    }

    if (this.state.inletsLoaded && !force) {
      return Promise.resolve(this.state.device?.inlets || []);
    }

    this.setState({ inletsLoading: true });

    const encodedSerial = encodeURIComponent(targetSerial);
    const request = axios
      .get(`/v2/devices/${encodedSerial}/inlets`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const inlets = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.setDeviceData(
          { enclosureSerialNumber: targetSerial, inlets },
          {
            inletsLoading: false,
            inletsLoaded: true,
            deviceOffline: false,
            deviceOfflineReason: null,
          }
        );
        return inlets;
      })
      .catch((err) => {
        if (this.isOfflineError(err)) {
          const inlets = Array.isArray(err?.response?.data?.data)
            ? err.response.data.data
            : [];
          const message = this.offlineMessageFromError(
            err,
            "Device is offline. Showing last known inlet information."
          );

          this.setDeviceData(
            { enclosureSerialNumber: targetSerial, inlets },
            {
              inletsLoading: false,
              inletsLoaded: true,
              deviceOffline: true,
              deviceOfflineReason: message,
            }
          );
          return inlets;
        }

        console.error(err);
        this.setState({ inletsLoading: false });
        throw err;
      })
      .finally(() => {
        this.inletsRequest = null;
      });

    this.inletsRequest = request;
    return request;
  };

  fetchDeviceBanks = ({ serial, force = false } = {}) => {
    const targetSerial = serial || this.currentSerial();
    if (!targetSerial) return Promise.resolve([]);

    if (this.state.banksLoading && this.banksRequest) {
      return this.banksRequest;
    }

    if (this.state.banksLoaded && !force) {
      return Promise.resolve(this.state.device?.banks || []);
    }

    this.setState({ banksLoading: true });

    const encodedSerial = encodeURIComponent(targetSerial);
    const request = axios
      .get(`/v2/devices/${encodedSerial}/banks`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const banks = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.setDeviceData(
          { enclosureSerialNumber: targetSerial, banks },
          {
            banksLoading: false,
            banksLoaded: true,
            deviceOffline: false,
            deviceOfflineReason: null,
          }
        );
        return banks;
      })
      .catch((err) => {
        if (this.isOfflineError(err)) {
          const banks = Array.isArray(err?.response?.data?.data)
            ? err.response.data.data
            : [];
          const message = this.offlineMessageFromError(
            err,
            "Device is offline. Showing last known bank information."
          );

          this.setDeviceData(
            { enclosureSerialNumber: targetSerial, banks },
            {
              banksLoading: false,
              banksLoaded: true,
              deviceOffline: true,
              deviceOfflineReason: message,
            }
          );
          return banks;
        }

        console.error(err);
        this.setState({ banksLoading: false });
        throw err;
      })
      .finally(() => {
        this.banksRequest = null;
      });

    this.banksRequest = request;
    return request;
  };

  fetchDeviceSensors = ({ serial, force = false } = {}) => {
    const targetSerial = serial || this.currentSerial();
    if (!targetSerial) return Promise.resolve([]);

    if (this.state.sensorsLoading && this.sensorsRequest) {
      return this.sensorsRequest;
    }

    if (this.state.sensorsLoaded && !force) {
      return Promise.resolve(this.state.device?.sensors || []);
    }

    this.setState({ sensorsLoading: true });

    const encodedSerial = encodeURIComponent(targetSerial);
    const request = axios
      .get(`/v2/devices/${encodedSerial}/sensors`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const sensors = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.setDeviceData(
          { enclosureSerialNumber: targetSerial, sensors },
          {
            sensorsLoading: false,
            sensorsLoaded: true,
            deviceOffline: false,
            deviceOfflineReason: null,
          }
        );
        return sensors;
      })
      .catch((err) => {
        if (this.isOfflineError(err)) {
          const sensors = Array.isArray(err?.response?.data?.data)
            ? err.response.data.data
            : [];
          const message = this.offlineMessageFromError(
            err,
            "Device is offline. Showing last known sensor information."
          );

          this.setDeviceData(
            { enclosureSerialNumber: targetSerial, sensors },
            {
              sensorsLoading: false,
              sensorsLoaded: true,
              deviceOffline: true,
              deviceOfflineReason: message,
            }
          );
          return sensors;
        }

        console.error(err);
        this.setState({ sensorsLoading: false });
        throw err;
      })
      .finally(() => {
        this.sensorsRequest = null;
      });

    this.sensorsRequest = request;
    return request;
  };

  fetchDeviceEvents = ({ serial, force = false } = {}) => {
    const targetSerial = serial || this.currentSerial();
    if (!targetSerial) return Promise.resolve([]);

    if (this.state.eventsLoading && this.eventsRequest) {
      return this.eventsRequest;
    }

    if (this.state.eventsLoaded && !force) {
      return Promise.resolve(this.state.device?.events || []);
    }

    this.setState({ eventsLoading: true });

    const encodedSerial = encodeURIComponent(targetSerial);
    const request = axios
      .get(`/v2/devices/${encodedSerial}/events`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const events = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.setDeviceData(
          { enclosureSerialNumber: targetSerial, events },
          {
            eventsLoading: false,
            eventsLoaded: true,
            deviceOffline: false,
            deviceOfflineReason: null,
          }
        );
        return events;
      })
      .catch((err) => {
        if (this.isOfflineError(err)) {
          const events = Array.isArray(err?.response?.data?.data)
            ? err.response.data.data
            : [];
          const message = this.offlineMessageFromError(
            err,
            "Device is offline. Displaying last known event information."
          );

          this.setDeviceData(
            { enclosureSerialNumber: targetSerial, events },
            {
              eventsLoading: false,
              eventsLoaded: true,
              deviceOffline: true,
              deviceOfflineReason: message,
            }
          );
          return events;
        }

        console.error(err);
        this.setState({ eventsLoading: false });
        throw err;
      })
      .finally(() => {
        this.eventsRequest = null;
      });

    this.eventsRequest = request;
    return request;
  };
  fetchConf = ({ useCache = false, force = false, device: deviceOverride } = {}) => {
    const device = deviceOverride || this.state.device;
    const rawSerial =
      device?.enclosureSerialNumber || this.props.match.params.enclosureSerialNumber;

    if (!rawSerial) {
      return Promise.resolve(null);
    }

    const serial = String(rawSerial);
    const currentSerial =
      this.state.confSerial ?? this.state.conf?.enclosureSerialNumber ?? null;

    if (!force) {
      if (this.confRequest && this.confRequestSerial === serial) {
        return this.confRequest;
      }

      if (
        currentSerial === serial &&
        this.state.conf &&
        !this.state.confLoading
      ) {
        return Promise.resolve(this.state.conf);
      }

      if (this.state.confLoading && currentSerial === serial) {
        return this.confRequest || Promise.resolve(null);
      }
    }

    const isLtePdu = device?.modelNumber?.endsWith("M01");
    const shouldUseCache = useCache && !isLtePdu;

    this.setState((prevState) => {
      const prevSerial =
        prevState.confSerial ?? prevState.conf?.enclosureSerialNumber ?? null;
      const shouldKeepCurrent = !force && prevSerial === serial;

      return {
        confLoading: true,
        conf: shouldKeepCurrent ? prevState.conf : null,
        confSerial: shouldKeepCurrent ? prevState.confSerial : null,
      };
    });

    const request = axios
      .get(
        `/v2/conf?${shouldUseCache ? "cache=true" : "cache=false"}&enclosure_serial_number=${encodeURIComponent(
          serial
        )}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        if (!this.confRequest || this.confRequest === request) {
          this.setState({
            conf: (res.data?.data || [])[0] || null,
            confLoading: false,
            confSerial: serial,
          });
        }
        return (res.data?.data || [])[0] || null;
      })
      .catch((err) => {
        console.error(err);
        if (!this.confRequest || this.confRequest === request) {
          this.setState({ confLoading: false });
        }
        return null;
      })
      .finally(() => {
        if (this.confRequest === request) {
          this.confRequest = null;
          this.confRequestSerial = null;
        }
      });

    this.confRequest = request;
    this.confRequestSerial = serial;

    return request;
  };
  grabActivityLog = (page = 1, action = this.state.activityFilter) => {
    this.setState({
      activityLoading: true,
    });
    const actionParam = action ? `&action=${action}` : "";
    axios
      .get(
        `/v2/activity?enclosure_serial_number=${this.props.match.params.enclosureSerialNumber}&limit=10&page=${page}${actionParam}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        this.setState({
          activityLog: res.data.data,
          activityMeta: res.data.meta || {},
          activityPage: page,
          activityLoading: false,
          activityLoaded: true,
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  handleActivityFilter = (val) => {
    this.setState({ activityFilter: val }, () => this.grabActivityLog(1, val));
  };

  updateOutlet = (outletId, changes, cb = (err, udpatedOutlet) => {}) => {
    // axios call to /v1/outlets/OUTLET_ID as a PUT, body is changes
    axios
      .put(`/v1/outlets/${outletId}`, changes, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const returnedOutlet = res.data.data;
        cb(null, returnedOutlet);
        NotificationManager.success(
          `Outlet ${returnedOutlet.outlet_id} updated successfully`
        );
        // update state with the returned outlet. dont replace, add on
        this.setState((prevState) => {
          if (!prevState.device) return null;
          const updatedOutlets = prevState.device.outlets.map((outlet) => {
            if (outlet.outlet_id === returnedOutlet.outlet_id) {
              return {
                ...outlet,
                ...returnedOutlet,
              };
            }
            return outlet;
          });
          return {
            device: {
              ...prevState.device,
              outlets: updatedOutlets,
            },
          };
        });
        // if changes.state === "REBOOT", trigger a follow-up refresh after the reboot window
        if (changes.state == "REBOOT") {
          const rebootTimeInSeconds = returnedOutlet.customRebootTime;
          const rebootTimeInMs = rebootTimeInSeconds * 1000;
          setTimeout(() => {
            this.grabDeviceData();
            this.fetchDeviceOutlets({
              serial:
                returnedOutlet.enclosureSerialNumber || this.currentSerial(),
              force: true,
            });
          }, rebootTimeInMs);
        }
      })
      .catch((err) => {
        console.error(err);
        NotificationManager.alert(
          `Failed to update outlet ${outletId}`
        );
        cb(err);
      });
  };

  createEvent = (enclosureSerialNumber, newEvent, cb = () => {}) => {
    // axios call to /v1/devices/:enclosureSerialNumber/events POST
    axios
      .post(
        `/v1/devices/${enclosureSerialNumber}/events`,
        newEvent,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        NotificationManager.success(
          `Event ${res.data.data.name} created successfully`
        );
        cb(null, res.data.data);
        this.setState((prevState) => {
          if (!prevState.device) return null;
          return {
            device: {
              ...prevState.device,
              events: [...prevState.device.events, res.data.data],
            },
            eventsLoaded: true,
          };
        });
      })
      .catch((err) => {
        cb(err)
        console.error(err);
        NotificationManager.alert(
          `Failed to create event ${newEvent.event_id}`
        );
      });



  }
  removeEvent = (enclosureSerialNumber, eventId, cb = () => {}) => {
    // axios call to /v1/devices/:enclosureSerialNumber/events/:eventId DELETE
    axios
      .delete(
        `/v1/devices/${enclosureSerialNumber}/events/${eventId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        NotificationManager.success(
          `Event ${eventId} deleted successfully`
        );
        cb(null, res.data.data);
        this.setState((prevState) => {
          if (!prevState.device) return null;
          return {
            device: {
              ...prevState.device,
              events: prevState.device.events.filter(
                (event) => event.id !== eventId
              ),
            },
            eventsLoaded: true,
          };
        });
      })
      .catch((err) => {
        cb(err)
        console.error(err);
        NotificationManager.alert(
          `Failed to delete event ${eventId}`
        );
      });
  }

  updateEvent = (enclosureSerialNumber, eventId, changes, cb = () => {}) => {
    // axios call to /v1/devices/:enclosureSerialNumber/events/:eventId PUT
    axios
      .put(
        `/v1/devices/${enclosureSerialNumber}/events/${eventId}`,
        changes,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        NotificationManager.success(
          `Event ${eventId} updated successfully`
        );
        cb(null, res.data.data);
        this.setState((prevState) => {
          if (!prevState.device) return null;
          return {
            device: {
              ...prevState.device,
              events: prevState.device.events.map((event) =>
                event.id == eventId ? { ...event, ...changes } : event
              ),
            },
            eventsLoaded: true,
          };
        });
      })
      .catch((err) => {
        cb(err)
        console.error(err);
        NotificationManager.alert(
          `Failed to update event ${eventId}`
        );
      });
  
  }
  unpair = (cb = () => {}) => {
    this.props.removeResource(
      "devices",
      this.props.match.params.enclosureSerialNumber,
      (err, res) => {
        cb();
        this.props.history.replace("/devices/connected");
      },
      "enclosureSerialNumber"
    );
  };

  sections = () => {
    return [
      {
        label: "Details",
        icon: "public",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/details`,
        component: DeviceDetails,
        props: {
          ...this.props,
          device: this.state.device,
          deviceLoading: this.state.deviceLoading,
          deviceLoaded: this.state.deviceLoaded,
          conf: this.state.conf,
          confLoading: this.state.confLoading,
          refreshConf: this.fetchConf,
          user: this.props.user,
          activityLog: this.state.activityLog,
          activityMeta: this.state.activityMeta,
          activityPage: this.state.activityPage,
          activityLoading: this.state.activityLoading,
          grabActivityLog: this.grabActivityLog,
          onFilter: this.handleActivityFilter,
          unpair: this.unpair,
        },
      },
      {
        label: "Power Consumption",
        icon: "power",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/inlets`,
        props: {
          inlets: this.state.device?.inlets || [],
          banks: this.state.device?.banks || [],
          device: this.state.device,
          loading: this.state.inletsLoading,
          loaded: this.state.inletsLoaded,
          user: this.props.user,
        },
        component: DevicePageInlet,
        disabled: this.props.user.role && !this.props.user.role.viewInletInfo,
      },
      {
        label: "Manage Outlets",
        icon: "outlet",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/outlets`,
        props: {
          outlets: this.state.device?.outlets || [],
          device: this.state.device,
          loading: this.state.outletsLoading,
          loaded: this.state.outletsLoaded,
          user: this.props.user,
          activityLog: this.state.activityLog,
          activityLoading: this.state.activityLoading,
          grabActivityLog: this.grabActivityLog,
          updateOutlet: this.updateOutlet,
          history: this.props.history,
          refreshOutlets: this.fetchDeviceOutlets,
          refreshDevice: this.grabDeviceData,
        },
        exact: true,
        disabled:
          !(
            this.state.device?.outletSwitchingSupported ||
            this.state.device?.outletPwrMeasurementsSupported
          ) ||
          (this.props.user.role && !this.props.user.role.viewAllOutletsAllowed),
        component: DevicePageOutlets,
      },
      {
        label: "Manage Outlets",
        icon: "outlet",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/outlets/:section_id`,
        props: {
          outletId: this.props.match.params.section_id,
          outlets: this.state.device?.outlets || [],
          device: this.state.device,
          loading: this.state.outletsLoading,
          loaded: this.state.outletsLoaded,
          user: this.props.user,
          updateOutlet: this.updateOutlet,
          activityLog: this.state.activityLog,
          activityLoading: this.state.activityLoading,
          history: this.props.history,
          refreshOutlets: this.fetchDeviceOutlets,
        },
        component: DevicePageOutletPage,
        unlisted: true
        // disabled: true,
      },
      {
        label: "Alert Settings",
        icon: "notifications",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/alerts/:eventId`,
        component: DevicePageAlertItemPage,
        props: {
          device: this.state.device,
          banks: this.state.device?.banks || [],
          outlets: this.state.device?.outlets || [],
          sensors: this.state.device?.sensors || [],
          loading: this.state.deviceLoading,
          inlets: this.state.device?.inlets || [],
          loaded: this.state.deviceLoaded,
          events: this.state.device?.events || [],
          match: this.props.match,
          history: this.props.history,
          createEvent: this.createEvent,
          removeEvent: this.removeEvent,
          updateEvent: this.updateEvent,
          deviceOffline: this.state.deviceOffline,
          offlineReason: this.state.deviceOfflineReason,
        },
        unlisted: true
      },
      {
        label: "Alerts",
        icon: "notifications",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/alerts`,
        disabled: this.props.user.role && !this.props.user.role.viewEventInfo,
        component: DevicePageAlerts,
        props: {
          device: this.state.device,
          loading: this.state.eventsLoading,
          loaded: this.state.eventsLoaded,
          events: this.state.device?.events || [],
          banks: this.state.device?.banks || [],
          sensors: this.state.device?.sensors || [],
          refreshEvents: this.fetchDeviceEvents,
          deviceOffline: this.state.deviceOffline,
          offlineReason: this.state.deviceOfflineReason,
        }
      },
      {
        label: "Event Logs",
        icon: "history",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/event-logs`,
        disabled: this.props.user.role && !this.props.user.role.viewEventInfo,
        component: LoggingEventLogs,
        props: {
          ...this.props,
          device: this.state.device,
          location: this.props.location,
          history: this.props.history,
        },
      },
      {
        label: "Configuration",
        icon: "settings",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/configuration`,
        component: DevicePageConfiguration,
        props: {
          device: this.state.device,
          conf: this.state.conf,
          confLoading: this.state.confLoading,
          refreshConf: this.fetchConf,
          user: this.props.user,
          deviceOffline: this.state.deviceOffline,
          offlineReason: this.state.deviceOfflineReason,
        },
      },
      {
        label: "Sensors",
        icon: "device_thermostat",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/sensors`,
        disabled: this.props.user.role && !this.props.user.role.viewSensorInfo,
        component: () => (
          <DevicePageSensors
            {...this.props}
            resources={{
              ...this.props.resources,
              sensors: this.props.resources.sensors.filter(
                (d) =>

                  d.enclosureSerialNumber ==
                  this.props.match.params.enclosureSerialNumber
              ),
            }}
          />
        ),
      }
    ];
  };
  render() {
    const sections = this.sections();
    const isRefreshing =
      this.state.deviceLoading ||
      this.state.outletsLoading ||
      this.state.inletsLoading ||
      this.state.banksLoading ||
      this.state.sensorsLoading ||
      this.state.eventsLoading ||
      this.state.confLoading;

    const statusPending = !this.state.deviceLoaded;
    const offline = !statusPending && this.state.deviceOffline;
    const statusMessage = statusPending
      ? "Checking current device connection…"
      : offline
      ? 
        "Device is offline. Displaying last known information."
      : "Device is online. Data reflects the latest live readings.";

    const statusStyles = statusPending
      ? {
          background: "#f3f4f6",
          border: "1px solid #d1d5db",
          color: "#374151",
        }
      : offline
      ? {
          background: "#fff8e1",
          border: "1px solid #f6c343",
          color: "#7c6f15",
        }
      : {
          background: "#ecfdf5",
          border: "1px solid #6ee7b7",
          color: "#047857",
        };

    // console.log(sections);
    // if (this.state.deviceLoading) {
    //   return <Loading black />
    // }
    // const foundDevice = this.props.resources.devices.find(d => d.enclosureSerialNumber === this.props.match.params.enclosureSerialNumber);
    return (
      <div>
        <SubHeader
          sections={sections
            .filter((section) => !section.disabled)
            .filter((section) => !section.unlisted)}
        />
        <div style={{ padding: "0 24px" }}>
          <div
            style={{
              marginTop: "16px",
              marginBottom: "8px",
              padding: "16px 20px",
              borderRadius: "6px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "16px",
              ...statusStyles,
            }}
          >
            <div style={{ flex: "1 1 260px", minWidth: 0 }}>
              <div
                style={{
                  fontSize: "12px",
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                  fontWeight: 600,
                  marginBottom: "4px",
                }}
              >
                Device Status · {statusPending
                  ? "Checking"
                  : offline
                  ? "Offline"
                  : "Online"}
              </div>
              <div
                style={{
                  fontSize: "14px",
                  lineHeight: 1.5,
                  color: statusPending
                    ? "#374151"
                    : offline
                    ? "#7c6f15"
                    : "#1f2937",
                }}
              >
                {statusMessage}
              </div>
            </div>
            {!statusPending && !offline ? (
              <button
                type="button"
                className="button primary"
                onClick={this.refreshAllData}
                disabled={isRefreshing}
                aria-label={
                  isRefreshing ? "Refreshing device data" : "Refresh device data"
                }
                title={
                  isRefreshing ? "Refreshing device data" : "Refresh device data"
                }
                style={{
                  padding: 0,
                  width: "44px",
                  height: "44px",
                  minWidth: "44px",
                  borderRadius: "9999px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  color: "#111827",
                  border: "none",
                  boxShadow: "0 0 0 1px rgba(17, 24, 39, 0.08)",
                  cursor: isRefreshing ? "default" : "pointer",
                  opacity: isRefreshing ? 0.7 : 1,
                  transition: "transform 0.2s ease, background-color 0.2s ease",
                }}
              >
                {isRefreshing ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <Loading black size="20px" />
                  </div>
                ) : (
                  <i
                    className="material-icons"
                    aria-hidden="true"
                    style={{ fontSize: "24px", lineHeight: 1 }}
                  >
                    refresh
                  </i>
                )}
              </button>
            ) : null}
          </div>
        </div>
        <Switch>
          {sections &&
            sections.map((section) => {
              // if (section.disableAccess) return null;
              if (section.disabled) return null;

              return (
                <Route
                  key={section.label}
                  path={section.path}
                  exact={section.exact}
                  render={(props) => {
                    if (section.disabled) {
                      return null;
                    }
                    // const CompToRender = scrollTopOnMount(section.component);
                    const CompToRender = section.component;
                    return (
                      <CompToRender
                        {...this.props}
                        {...(section.props || {})}
                        match={this.props.match}
                      />
                    );
                  }}
                />
              );
            })}
        </Switch>
      </div>
    );
  }
}
